import type { BifrostWeb } from '@seekrtech/bifrost-web'

export interface GeneralServiceMethods {
  close: () => Promise<void>
  logEvent: (payload: {
    event_name: string
    event_params?: Record<string, string>
  }) => Promise<void>
  openURL: (url: string) => Promise<void>
  pageReady: () => Promise<void>
  complete: () => Promise<void>
  getPageContext: () => Promise<{ initial_theme: number }>
  logFatalError: (payload: { name: string; reason: string }) => Promise<void>
  logNonFatalError: (payload: {
    name: string
    code: number
    params?: Record<string, string>
  }) => Promise<void>
}

export function createGeneralService(
  bifrost: BifrostWeb,
): GeneralServiceMethods {
  return bifrost.createNativeProxy<GeneralServiceMethods>('GeneralService')
}
